<input type="hidden" class="form-control" [(ngModel)]="familyFind" (ngModelChange)="searchFamily()">

<div class="cont_families">
  <div class="row">
    <div class="col-md-4 mb-3">
      <h4 class="my-3">Selector de familias y segmentos</h4>
      <ngb-accordion #acc="ngbAccordion" class="variable-accordion">
        <ngb-panel *ngFor="let segment of model">
          <ng-template ngbPanelHeader>
            <button ngbPanelToggle class="accordion-button">Segmento {{segment.Segment}} -
              {{segment.Description}}</button>
          </ng-template>

          <ng-template ngbPanelContent>
            <table class="table data-tables dense__table">
              <thead>
                <tr>
                  <th class="text-center w-6">Familia</th>
                  <th>Nombre</th>
                  <th><button
                      [ngClass]="{'btn-option-minus': addSegmentFormIsVisible,'btn-option-plus': !addSegmentFormIsVisible}"
                      type="button" class="btn-option btn-option-darken" (click)="showAddSegmentForm()"
                      title="Añadir segmento completo"><span class="visually-hidden">Añadir segmento completo</span></button></th>
                </tr>
              </thead>
              <tbody>
                <tr [hidden]="!addSegmentFormIsVisible">
                  <td colspan="3">
                    <div class="text-start p-3">
                      <h6>Añadir segmento completo</h6>
                      <p class="mb-3">Si lo deseas puedes añadir los valores máximos y mínimos de
                        {{textCantidadUnidad}}.</p>
                        <div class="box__range">
                      <div class="row mb-3">
                        <div class="col mb-2">
                          <label [for]="'pvpMinSegmentInput' + segment.Segment" class="form-label">{{textCantidadUnidad
                            | titlecase}} desde</label>
                          <input type="number" class="form-control text-start" #pvpMinInput
                            [id]="'pvpMinSegmentInput' + segment.Segment">
                        </div>
                        <div class="col mb-2">
                          <label [for]="'pvpMaxSegmentInput' + segment.Segment" class="form-label">{{textCantidadUnidad
                            | titlecase}} hasta</label>
                          <input type="number" class="form-control text-start" #pvpMaxInput
                            [id]="'pvpMaxSegmentInput' + segment.Segment">
                        </div>
                      </div>
                    </div>
                      <div class="row">
                        <div class="col text-end mb-2"><button type="button" class="btn-yw"
                            (click)="addSegment(segment.Segment, segment.IdSegment, segment.Description, pvpMinInput.value, pvpMaxInput.value)">Añadir
                            segmento completo</button></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr *ngFor="let family of segment.Familiy">
                  <td class="text-center">{{family.Family}}</td>
                  <td>{{family.Description}}</td>
                  <td class="text-center w-4">
                    <div class="cont__btn-option"><button type="button" class="btn-option btn-option-plus"
                        (click)="addFamily(family, segment.Segment, segment.Description)" title="Añadir familia"><span
                          class="visually-hidden">Añadir familia</span></button></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
    <div class="col-md-8 mb-3">
      <div class="d-block position-sticky top-0">
        <div class="box__border d-flex justify-content-between align-items-center gap-lg-3 mt-5 pb-2">
          <div>Recuerda <strong>APLICAR LA SEGMENTACIÓN</strong> del formulario para que los cambios realizados en las familias seleccionadas se apliquen.</div>
          <button type="button" class="btn btn-blue" data-bs-dismiss="modal">APLICAR Y CERRAR</button>
        </div>
        <div *ngIf="selectedSegments.length>0">
          <h4 class="my-3">Familias seleccionadas</h4>
        </div>

        <div *ngIf="selectedSegments.length>0" class="table-responsive-lg pb-lg-0">
          <table class="table data-tables dense__table">
            <thead>
              <tr>
                <th class="text-center w-6">Segmento</th>
                <th>Denominación</th>
                <th class="text-center w-12">{{textCantidadUnidad}} desde</th>
                <th class="text-center w-12">{{textCantidadUnidad}} hasta</th>
                <th class="text-center w-4"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let segment of selectedSegments">
                <td class="text-center">{{segment.Segment}}</td>
                <td>{{segment.SegmentDescription}}</td>
                <td>
                  <input type="number" class="form-control" [(ngModel)]="segment.PvpMin"
                    (ngModelChange)="emitSelection()">
                </td>
                <td class="text-center">
                  <input type="number" class="form-control" [(ngModel)]="segment.PvpMax"
                    (ngModelChange)="emitSelection()">
                </td>
                <td>
                  <div class="cont__btn-option"><button type="button" class="btn-option btn-option-minus"
                      (click)="removeSegment(segment.IdSegment)" title="Eliminar"><span
                        class="visually-hidden">Eliminar</span></button></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h4 *ngIf="selectedFamilies.length>0" class="my-3">Familias seleccionadas</h4>
        <ngb-accordion #acc="ngbAccordion" class="variable-accordion" [activeIds]="activeTabsIds">
          <ngb-panel *ngFor="let segment of selectedFamilies" [id]="'selectedSegment' + segment.IdSegment">
            <ng-template ngbPanelHeader>
              <button ngbPanelToggle class="accordion-button">Segmento {{segment.Segment}} -
                {{segment.SegmentDescription}}</button>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="table-responsive-lg pb-lg-0">
                <table class="table data-tables dense__table">
                  <thead>
                    <tr>
                      <th class="text-center w-6">Familia</th>
                      <th>Nombre</th>
                      <th class="text-center w-12">{{textCantidadUnidad}} desde</th>
                      <th class="text-center w-12">{{textCantidadUnidad}} hasta</th>
                      <th class="text-center w-4"><button type="button"
                          class="btn-option btn-option-minus btn-option-darken"
                          (click)="removeFamilySegment(segment.IdSegment)" title="Quitar segmento"><span
                            class="visually-hidden">Quitar segmento</span></button></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let family of segment.Families">
                      <td class="text-center">{{family.Family}}</td>
                      <td>{{family.Description}}</td>
                      <td>
                        <input type="number" class="form-control" [(ngModel)]="family.PvpMin"
                          (ngModelChange)="emitSelection()">
                      </td>
                      <td class="text-center">
                        <input type="number" class="form-control" [(ngModel)]="family.PvpMax"
                          (ngModelChange)="emitSelection()">
                      </td>
                      <td>
                        <div class="cont__btn-option"><button type="button" class="btn-option btn-option-minus"
                            (click)="removeFamily(family)" title="Eliminar"><span
                              class="visually-hidden">Eliminar</span></button></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
  </div>
</div>